import { ErrorIcon } from '@icons'

import cn from '@integrations/classnames'
import styles from './ErrorFallback.module.scss'

interface Props {
  resetErrorBoundary: () => void
}

function ErrorFallback({ resetErrorBoundary }: Props) {
  return (
    <div className={cn(styles['error-fallback-wrapper'], 'error-fallback-wrapper')}>
      <div className={cn(styles['error-fallback-content'], 'error-fallback-content')}>
        <ErrorIcon />
        <p>An unexpected error occurred</p>
        <button type='button' onClick={resetErrorBoundary}>
          Go back to the home page
        </button>
      </div>
    </div>
  )
}

export default ErrorFallback
